import { ReactNode, useEffect, useState } from "react";

function isStorageAvailable(type: "localStorage" | "sessionStorage"): boolean {
    try{
        const storage = window[type];
        const testKey = "__storage_test__";
        storage.setItem(testKey, testKey);
        storage.removeItem(testKey);
        return true;
    } catch {
        return false;
    }
}

const StorageGate = ({children}: {children: ReactNode}) => {
    
    const [storageOk, setStorageOk] = useState<boolean | null>(null);

    useEffect(() => {
        const local = isStorageAvailable("localStorage");
        const session = isStorageAvailable("sessionStorage");

        setStorageOk(local || session);

        /*
        // For testing
        const checkStorage = () => {
            const local = isStorageAvailable("localStorage");
            const session = isStorageAvailable("sessionStorage");
            setStorageOk(local || session );
        };

        checkStorage(); // initial check
        const interval = setInterval(checkStorage, 5000);

        return () => clearInterval(interval);
        */

    }, []);
    
    if(storageOk === null) return null;

    if(!storageOk) {
        return (
           <div style={{
            backgroundColor: "#fff3cd",
            color: "#856404",
            padding: "2rem",
            fontFamily: "sans-serif",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
        }}>
            <h1>⚠️ Begrenset funksjonalitet</h1>
            <p>
                Nettleseren din har deaktivert lokal lagring (f.eks. <code>localStorage</code>).
                Dette kan skje i privat modus eller på grunn av strenge personverninnstillinger.
            </p>
            <p>
                Min bedrift krever lokal lagring for å fungere. Vennligst åpne siden i vanlig nettlesermodus eller juster innstillingene dine.
            </p>
        </div> 
        );
    }

    return <>{children}</>
}

export default StorageGate;